<template>
  <div style="color: #adadad">
    <div style="cursor: pointer;margin-bottom: 16px" @click="back">
      <a-icon type="left" style="margin-right: 2px" />
      <span>返回</span>
    </div>

    <a-row>
      <a-col :span="12">分类：
        <DataDictFinder dictType="cutoffWellType" :dictValue="record.subType" />
      </a-col>
      <a-col :span="12">编号： {{ record.code }}</a-col>
    </a-row>

    <div style="padding-top: 16px"></div>

    <Tablelist
            :showCheckbox="false"
            :list="list"
            :columns="tableColumns"
            :totalSize="totalSize"
            :totalPages="totalPages"
            :pageNum="pageNum"
            :pageSize="pageSize"
            @page-change="onChange"
    >
        <template #template-type="{ item }">
            <DataDictFinder dictType="taskType" :dictValue="item.type" />
        </template>
        <template #template-status="{ item }">
            <DataDictFinder dictType="taskStatus" :dictValue="item.status" iconType="badge" badgeType="color" />
        </template>
    </Tablelist>
    <div v-if="list.length === 0" style="padding-top: 16px"></div>
  </div>
</template>
<script>
import { fetchRecordList } from "@/api/assets/index.js";

export default {
  props: {
    record: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      list: [],
      loading: false,
      totalSize: 1,
      totalPages: 1,
      pageNum: 1,
      pageSize: 10,
      tableColumns:[
            {
                key: 'number',
                title: '任务单号',
                field: 'number',
                infotype: 'text',
                width: '150px'
            },
            {
                key: 'type',
                title: '维保类型',
                field: 'type',
                infotype: 'template',
                width: '100px'
            },
            {
                key: 'taskTime',
                title: '任务创建日期',
                field: 'taskTime',
                infotype: 'text',
                width: '100px'
            },
            {
                key: 'finishTime',
                title: '任务完成日期',
                field: 'finishTime',
                infotype: 'text',
                width: '100px'
            },
            {
                key: 'executorName',
                title: '执行人',
                field: 'executorName',
                infotype: 'text',
                width: '100px'
            },
            {
                key: 'status',
                title: '状态',
                field: 'status',
                infotype: 'text',
                width: '100px'
            }
        ]
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    onChange(pagination) {
        this.pageNum  = pagination;
        this.pageSize = 10;
        this.getList();
    },
    getList() {
      let { id } = this.record;
      this.loading = true;
      fetchRecordList({
        deviceId: id,
        type: "cutoffWell",
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res)) {
            this.list = res;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    back() {
      this.$emit("cancel");
    },
  },
};
</script>